export default "__VITE_ASSET__BrxHQPBN__"